// extracted by mini-css-extract-plugin
export default {"fontFamily":"orderPdf_fontFamily__lb2hZ","tableBg":"orderPdf_tableBg__29zrK"};